export * from './TextAlignRightJustifyIcon';
export * from './TextAlignRightJustifyIcon16Light';
export * from './TextAlignRightJustifyIcon16Regular';
export * from './TextAlignRightJustifyIcon16Solid';
export * from './TextAlignRightJustifyIcon20Light';
export * from './TextAlignRightJustifyIcon20Regular';
export * from './TextAlignRightJustifyIcon20Solid';
export * from './TextAlignRightJustifyIcon24Regular';
export * from './TextAlignRightJustifyIcon24Solid';
export * from './TextAlignRightJustifyIcon32Regular';
export * from './TextAlignRightJustifyIcon64Regular';
